import { createSlice } from '@reduxjs/toolkit';

interface AuthState {
    isLogin: boolean,
    user: any
}

const initialState: AuthState = {
    isLogin: (localStorage.getItem("usertoken") as any) ? true : false,
    user: null
}

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        login: (state) => {
            state.isLogin = true;
        },
        logout: (state) => {
            state.isLogin = false;
            localStorage.removeItem("usertoken");
        },
        userDetail: (state, action) => {
            state.user = action.payload;
        },
    }
});

export default authSlice;
export const authActions = authSlice.actions;